module.exports = __webpack_public_path__ + "static/media/charity-palate-surgery.62ccbd2e.svg";